import { ThrowReporter } from "io-ts/lib/ThrowReporter";
import { left } from "fp-ts/lib/Either";
export const fetchJSON = ({ url, decode }) => {
    return fetch(url, { headers: { Accept: "application/json" } })
        .then(response => {
        if (!response.ok || response.status === 204) {
            throw new Error(response.status + " " + response.statusText);
        }
        return response.json();
    })
        .then(json => {
        const decoded = decode(json);
        ThrowReporter.report(decoded);
        return decoded;
    })
        .catch((e) => left(e));
};



// WEBPACK FOOTER //
// ./src/api/fetchJSON.ts